<template>
    <div class="catalog-item">
        <div class="catalog-item__img-wrapper">
            <img class="catalog-item__img" :src="'https://lenbuket.ru:8443/' + product_data.url" @click="productClick(product_data)">
            <p 
                v-if="!product_data.isLoyalty"
                class="catalog-item__loyalty">На товар не распространяются скидки и промокоды</p>
        </div>

        <p class="catalog-item__name">{{product_data.name}}</p>
        <div 
            class="catalog-item__footer"
            :class="{additional_footer: product_data.isAdditional}">
            <p 
                class="catalog-item__price">{{product_data.price}} <span class="catalog-item__qurency">₽</span></p>
            <button 
                class="catalog-item__btn" 
                @click="addToCart"
                v-if="curRouter != 'Admin-page'">В корзину</button>
        </div> 
    </div>
</template>

<script>
import {mapActions} from 'vuex'

export default {
    props: {
        product_data: {
            type: Object,
            default(){
                return{

                }
            }
        }
    },
    computed: {
        curRouter(){
            return this.$route.name
        }
    },
    methods: {
        ...mapActions([
            'GET_ONE_PRODUCT',
            'ADD_TO_CART'
        ]),
        addToCart(){
            this.ADD_TO_CART(this.product_data)
            this.$emit('addToCart', null)
        },
        productClick(){
            this.$router.push({name: 'product', params: {'flower': this.product_data.pageUrl}})
        }
    },
}
</script>

<style scoped>
    .catalog-item{
        display: flex;
        flex-direction: column;
        color: #3A3841;
    }
    .catalog-item__img-wrapper{
        position: relative;
        display: flex;
    }
    .catalog-item__img{
        width: 100%;
        aspect-ratio: 1 / 1;
        margin-bottom: 15px;
        border-radius: 10px;
        transition: all linear .2s;
    }
    .catalog-item__img:hover{
        transform: scale(.95);
        cursor: pointer;
    }
    .catalog-item__name{
        font-size: 20px;
        margin-bottom: 10px;
        min-height: 60px;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
    }
    .catalog-item__price{
        font-family: "Literata", serif;
        font-size: 20px;
        margin-right: 15px;
    }
    .catalog-item__qurency{
        font-size: 20px;
    }
    .catalog-item__footer{
        margin-top: auto;
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
    }
    .catalog-item__btn{
        position: relative;
        font-size: 20px;
        font-family: "Bona Nova", serif;
        color: #3A3841;
    }
    .catalog-item__btn::after{
        position: absolute;
        content: "";
        height: 1px;
        width: 100%;
        background-color: #3A3841;
        bottom: 1px;
        left: 0;
        transition: all linear .1s;
    }
    .catalog-item__btn:hover::after{
        opacity: 0;
    }
    .outOfStock{
        opacity: .5;
        pointer-events: none;
    }
    .priceHeight{
        min-height: auto;
    }
     .catalog-item__loyalty{
        position: absolute;
        bottom: 8px;
        right: 8px;
        border-radius: 6px;
        background-color: rgba(255, 255, 255, .8);
        padding: 4px;
        color: #9C9BA0;
        font-size: 14px;
    }
    @media (max-width: 992px){
        .catalog-item__name{
            font-size: 16px;
            display: block;
        }
        .catalog-item__price{
            font-size: 20px;
        }
        .catalog-item__qurency{
            font-size: 18px;
        }
        .catalog-item__btn{
            text-transform: none;
        }
    }
    @media (max-width: 768px) {
        .catalog-item__price{
            font-size: 18px;
        }
        .catalog-item__btn{
            font-size: 18px;
            margin-right: 0;
        }
    }
    @media (max-width: 600px){
        .catalog-item__img{
            margin-bottom: 10px;
            min-width: auto;
        }
        .catalog-item__price{
            font-size: 18px;
            font-weight: 500;
        }
        .catalog-item__qurency{
            font-size: 16px;
        }
        .catalog-item__btn{
            font-size: 18px;
        }
        .additional_footer{
            flex-direction: column;
            align-items: flex-start;
            font-size: 14px;
        }
        .additional_footer .catalog-item__btn{
            margin-top: 10px;
        }
        .catalog-item__name{
            margin-bottom: 15px;
            font-size: 18px;
        }
        .catalog-item__loyalty{
            right: auto;
            left: 8px;
            bottom: 8px;
        }
    }
</style>